import React from "react";
import "./EraPage.css"; // shared stylesheet

function AncientGreeceRome() {
  return (
    <div className="era-page">
      {/* Banner Section */}
      <div className="era-banner greco-banner">
        <h1>🏛️ Ancient Greece & Rome</h1>
        <p className="era-subtitle">Grade 3 – World Cultures & Myths</p>
      </div>

      {/* Overview */}
      <section className="greco-overview">
        <h2>🌍 What Were Ancient Greece and Rome?</h2>
        <p>
          These two civilizations laid the foundation for modern governments, architecture,
          sports, philosophy, and storytelling. From Olympic games to the mighty Roman legions—
          they shaped the ancient world.
        </p>
      </section>

      {/* Key Figures / Events */}
      <section className="greco-key">
        <h2>🧠 Key People & Ideas</h2>
        <ul>
          <li>⚖️ <strong>Socrates & Plato</strong> - Famous philosophers from Greece.</li>
          <li>🏟️ <strong>The Olympics</strong> - Started in ancient Greece!</li>
          <li>🦅 <strong>Julius Caesar</strong> - A Roman leader who changed history.</li>
          <li>⚔️ <strong>Roman Legions</strong> - Powerful soldiers of the empire.</li>
        </ul>
      </section>

      {/* Comic / Story Section */}
      <section className="greco-story">
        <h2>📖 Mini Story: “Hero of Athens”</h2>
        <p>
          Young Nico dreamed of becoming an Olympic runner. But when his town was challenged to a race
          by a Roman scout, Nico had to train hard and represent all of Athens in a race of honor!
        </p>
      </section>

      {/* Quiz */}
      <section className="greco-quiz">
        <h2>🎮 Quiz Time!</h2>
        <p><strong>Which two countries are known for starting democracy and the republic?</strong></p>
        <ul>
          <li>China & India</li>
          <li><strong>Greece & Rome ✅</strong></li>
          <li>Egypt & Persia</li>
          <li>France & England</li>
        </ul>
      </section>

      {/* Video */}
      <section className="greco-media">
        <h2>🎥 Watch & Learn</h2>
        <img
  className="greco-illustration"
  src="/images/ancient-greece-rome-scene.png" // rename as you like
  alt="Illustration of Greek and Roman landmarks, philosophers, Olympic athlete, Roman soldier"
  style={{ width: "100%", maxWidth: 500, borderRadius: "1.5rem", margin: "0 auto", boxShadow: "0 4px 24px rgba(0,0,0,0.12)" }}
/>
      </section>

      {/* Timeline */}
      <section className="greco-timeline">
        <h2>🕰️ Timeline Highlights</h2>
        <ul>
          <li>776 BCE – First Olympic Games</li>
          <li>509 BCE – Roman Republic begins</li>
          <li>44 BCE – Julius Caesar assassinated</li>
          <li>476 CE – Fall of the Western Roman Empire</li>
        </ul>
      </section>
    </div>
  );
}

export default AncientGreeceRome;
